import React, { Component } from 'react';

function importImages(r) {
  return r.keys().map(r);
}

function hsWidth(x) {
  return window.innerHeight * x
}

let imgStyle = {
  width: window.innerWidth,
  maxHeight: window.innerHeight
}

let hsStyle = {
  height: '10%',
  width: hsWidth(.1)
}

let caStyle = {
  height: '18%',
  width: hsWidth(.18)
}

const images = importImages(require.context("../../public/images/main-screens", false, /\.(png|jpe?g|svg)$/));

class Landing extends Component {
  state = {
    index: 0
  }
  render () {

    return (
      <div className="landing">
        <img className="landing-img" style={imgStyle} alt='background image' src={images[this.state.index]}/>
        { this.state.index < 8 ?
          <div>
            <div className="hotspot hotspot-00" style={hsStyle} onClick={() => this.setState({index: 0})} onMouseEnter={() => this.setState({index: 0})}/>
            <div className="hotspot hotspot-01" style={hsStyle} onClick={() => this.setState({index: 1})} onMouseEnter={() => this.setState({index: 1})}/>
            <div className="hotspot hotspot-02" style={hsStyle} onClick={() => this.setState({index: 2})} onMouseEnter={() => this.setState({index: 2})}/>
            <div className="hotspot hotspot-03" style={hsStyle} onClick={() => this.setState({index: 3})} onMouseEnter={() => this.setState({index: 3})}/>
            <div className="hotspot hotspot-04" style={hsStyle} onClick={() => this.setState({index: 4})} onMouseEnter={() => this.setState({index: 4})}/>
            <div className="hotspot hotspot-05" style={hsStyle} onClick={() => this.setState({index: 5})} onMouseEnter={() => this.setState({index: 5})}/>
            <div className="hotspot hotspot-06" style={hsStyle} onClick={() => this.setState({index: 6})} onMouseEnter={() => this.setState({index: 6})}/>
            <div className="hotspot hotspot-07" style={hsStyle} onClick={() => this.setState({index: 7})} onMouseEnter={() => this.setState({index: 7})}/>
          </div> :
          <div>
            <div className="hotspot hotspot-09" style={caStyle} onClick={() => this.setState({index: 9})} onMouseEnter={() => this.setState({index: 9})}/>
            <div className="hotspot hotspot-10" style={caStyle} onClick={() => this.setState({index: 10})} onMouseEnter={() => this.setState({index: 10})}/>
            <div className="hotspot hotspot-11" style={caStyle} onClick={() => this.setState({index: 11})} onMouseEnter={() => this.setState({index: 11})}/>
            <div className="hotspot hotspot-12" style={caStyle} onClick={() => this.setState({index: 12})} onMouseEnter={() => this.setState({index: 12})}/>
            <div className="hotspot hotspot-13" style={caStyle} onClick={() => this.setState({index: 13})} onMouseEnter={() => this.setState({index: 13})}/>
            <div className="hotspot hotspot-14" style={caStyle} onClick={() => this.setState({index: 14})} onMouseEnter={() => this.setState({index: 14})}/>
          </div>
        }
      </div>
    )
  }
}

export default Landing;

// { this.state.index === 1 ?
//   <div className="hotspot hotspot-08" style={hsStyle} onClick={() => this.setState({index: 8})}/>
//   : null
// }
// { this.state.index === 5 ?
//   <a className="hotspot hotspot-15" style={hsStyle} href="https://peopleproductions.com/what-we-do/#Content-Creation"/>
//   : null
// }
// { this.state.index === 6 ?
//   <a className="hotspot hotspot-16" style={hsStyle} href="https://peopleproductions.com/our-work/digital-applications/"/>
//   : null
// }
